<template>
    <div class="mobile-preview-frame">
        <div class="phone-frame">
            <div class="phone-notch"></div>
            <div class="screen-content custom-scrollbar">
                <!-- App Header -->
                <div class="app-header" :style="{ background: colors.primary_button || '#F27178', color: colors.text_navbar || '#ffffff' }">
                    <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 24px;">
                        <div>
                            <div style="font-size: 9px; opacity: 0.9; margin-bottom: 4px; font-weight: 500;">Hello, welcome to Dashboard 👋</div>
                            <div style="font-size: 15px; font-weight: 800;">Mr. John Doe</div>
                        </div>
                        <div class="avatar" :style="{ border: `1px solid ${colors.text_navbar || '#ffffff'}` }">
                           <img src="https://ui-avatars.com/api/?name=User&background=fca5a5&color=fff" alt="User" />
                        </div>
                    </div>
                </div>

                <!-- Balance Card -->
                <div class="balance-card-container">
                    <div class="balance-card">
                        <div style="font-size: 9px; color: #94a3b8; margin-bottom: 16px; font-weight: 600; letter-spacing: 0.5px;">MY MEMBERSHIP BALANCE</div>
                        
                        <div class="balance-stats">
                             <div class="stat-col">
                                <div class="stat-icon-wrapper">
                                    <i class="fas fa-shield-alt stat-icon" style="color: #cd7f32;"></i>
                                </div>
                                <span class="stat-label">TIER</span>
                                <span class="stat-value">Gold</span>
                             </div>
                             
                             <div class="stat-col flex-2">
                                <div class="stat-icon-wrapper">
                                    <i class="fas fa-coins stat-icon" style="color: #fbbf24;"></i>
                                </div>
                                <span class="stat-label">POINTS</span>
                                <span class="stat-value">1,250</span>
                                <span class="stat-sub">IDR XX.XXX</span>
                             </div>
                             
                             <div class="stat-col">
                                <div class="stat-icon-wrapper">
                                    <i class="fas fa-gift stat-icon" style="color: #ec4899;"></i>
                                </div>
                                <span class="stat-label">VOUCHERS</span>
                                <span class="stat-value">3</span>
                             </div>
                        </div>
                    </div>
                </div>

                <!-- Content Area -->
                <div style="padding: 16px;">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
                        <span style="font-size: 13px; font-weight: 800; color: #1e293b;">Member Promotion's</span>
                        <span style="font-size: 10px; color: #64748b; font-weight: 500;">View all</span>
                    </div>

                    <div class="horizontal-scroll pb-2">
                        <!-- Card 1 -->
                        <div class="promo-card mock-card-bg-1">
                            <span class="promo-badge" :style="{ color: colors.primary_button || '#F27178', backgroundColor: 'var(--secondary-color, #FEE9E9)' }">10 POIN</span>
                            <div class="promo-card-footer">
                                <div class="merchant-logo" :style="{ background: colors.primary_button || '#F27178' }">V</div>
                                <div class="promo-info">
                                    <div class="promo-title">Discount Voucher 50%</div>
                                    <div class="promo-subtitle">Merchant Area</div>
                                </div>
                            </div>
                        </div>

                        <!-- Card 2 -->
                        <div class="promo-card mock-card-bg-2">
                            <span class="promo-badge" :style="{ color: colors.primary_button || '#F27178', backgroundColor: 'var(--secondary-color, #FEE9E9)' }">BENEFIT</span>
                            <div class="promo-card-footer">
                                <div class="merchant-logo" :style="{ background: colors.primary_button || '#F27178' }">B</div>
                                <div class="promo-info">
                                    <div class="promo-title">Free Welcome Drink</div>
                                    <div class="promo-subtitle">Exclusive Member</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="bottom-nav">
                <div class="nav-item-pill active" :style="{ color: colors.primary_button || '#F27178', backgroundColor: 'var(--secondary-color, #FEE9E9)' }">
                    <i class="fas fa-chart-line"></i>
                    <span>Dashboard</span>
                </div>
                <div class="nav-item">
                    <i class="fas fa-history"></i>
                </div>
                <div class="nav-item">
                    <i class="fas fa-ticket-alt"></i>
                </div>
                <div class="nav-item">
                    <i class="fas fa-box-open"></i>
                </div>
                <div class="nav-item">
                    <i class="fas fa-qrcode"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OThemeMemberMobilePreview',
    props: {
        colors: { type: Object, required: true }
    }
}
</script>

<style scoped>
.mobile-preview-frame {
    display: flex;
    justify-content: center;
    background: #f8fafc;
    border-radius: 8px;
    padding: 16px;
    height: 100%;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px rgba(0,0,0,0.05);
}

.phone-frame {
    width: 250px;
    height: 500px;
    background: #ffffff;
    border: 10px solid #1e293b;
    border-radius: 30px;
    position: relative;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.phone-notch {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 90px;
    height: 20px;
    background: #1e293b;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    z-index: 10;
}

.screen-content {
    flex: 1;
    overflow-y: auto;
    background: #f8fafc;
}

.custom-scrollbar::-webkit-scrollbar {
    width: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 2px;
}

.app-header {
    padding: 36px 16px 60px;
    transition: background 0.3s;
}

.avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
}

.avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.balance-card-container {
    padding: 0 12px;
    margin-top: -45px;
}

.balance-card {
    background: white;
    border-radius: 16px;
    padding: 16px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.balance-stats {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
}

.stat-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    text-align: center;
}

.stat-col.flex-2 {
    flex: 1.2;
}

.stat-icon-wrapper {
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
}

.stat-icon {
    font-size: 26px;
}

.stat-label {
    font-size: 7px;
    font-weight: 700;
    color: #475569;
    margin-bottom: 4px;
}

.stat-value {
    font-size: 14px;
    font-weight: 800;
    color: #0f172a;
}

.stat-sub {
    font-size: 7px;
    color: #94a3b8;
    margin-top: 4px;
}

.horizontal-scroll {
    display: flex;
    overflow-x: auto;
    gap: 12px;
    -ms-overflow-style: none;  
    scrollbar-width: none;  
}

.horizontal-scroll::-webkit-scrollbar {
    display: none;
}

.promo-card {
    min-width: 180px;
    height: 200px;
    border-radius: 12px;
    position: relative;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 8px;
}

.mock-card-bg-1 {
    background-color: #1e293b;
}

.mock-card-bg-2 {
    background-color: #cbd5e1;
}

.promo-badge {
    position: absolute;
    top: 12px;
    right: -8px;
    background: #ffe4e6;
    padding: 4px 12px 4px 8px;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    font-size: 8px;
    font-weight: 800;
}

.promo-card-footer {
    background: #ffffff;
    border-radius: 16px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: -16px;
    padding-bottom: 24px;
}

.merchant-logo {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 9px;
    font-weight: 800;
    flex-shrink: 0;
}

.promo-info {
    flex: 1;
    overflow: hidden;
}

.promo-title {
    font-size: 11px;
    font-weight: 800;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.promo-subtitle {
    font-size: 8px;
    color: #64748b;
    margin-top: 2px;
}

.bottom-nav {
    height: 50px;
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px 4px 16px;
    border-top: 1px solid #f1f5f9;
}

.nav-item {
    color: #94a3b8;
    font-size: 14px;
    padding: 6px;
}

.nav-item-pill {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border-radius: 16px;
    font-size: 10px;
    font-weight: 700;
}
</style>
